import React, { useState, useEffect, useContext } from 'react'
import { useForm } from 'react-hook-form'
import { Button } from 'syngenta-react-components'
import clear from '../../assets/icons/clear.svg'
import TableStatus from '../../components/subComponents/TableStatus/TableStatus'
import { updateRole } from '../../services/apiHelper'
import { GlobalContext } from '../../services/context'


const EditRoleForm = ({
  roleName,
  handleClose,
  permisisonsData,
  handleDataRefresh
}) => {
  const [options, setOptions] = useState([])
  const [selectedPermissions, setSelectedPermissions] = useState()
  const [roleId, setRoleId] = useState()
  const [submissionStatus, setSubmissionStatus] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const { register, errors, clearError, handleSubmit, reset } = useForm()
  const { dispatch } = useContext(GlobalContext)
  
  useEffect(() => {
    permisisonsData.forEach(perm => {
      if (roleName === perm.role_name) {
        const compared = perm.permissionsData.map(permission => {
          return {
            permission_name: permission.display_name,
            permission_code: permission.permission,
            role_id: permission.role_id,
            isChecked: permission.isMatching
          }
        })
        setOptions(compared)
      }
    })
  }, [setOptions, handleDataRefresh, permisisonsData, roleName])

  useEffect(() => {
    const updatedArray = []
    options.forEach(option => {
      if (option.isChecked === true) {
        setRoleId(option.role_id)
        updatedArray.push(option.permission_code)
      }
    })
    setSelectedPermissions(updatedArray)
  }, [options])

  const onSubmit = formValues => {
    setSubmissionStatus('LOADING')
    let role_id = roleId
    let display_name = formValues.new_role_name
    let permissions = selectedPermissions.filter(function (permission_code) {
      return permission_code !== undefined
    })
    
    updateRole({ role_id, display_name, permissions }).then(res => {
      if (res?.status === 200) {
        setSubmissionStatus('SUCCESS')
        handleDataRefresh()
        
      } else {
        let errorMessage =
          (res?.data?.errors && res?.data?.errors[0]?.message) || ''
        setErrorMessage(errorMessage)
        setSubmissionStatus('FAILED')
      }
    })
    reset()
    clearError()
  }

  const handleCancelModal = () => {
    handleDataRefresh()
    reset()
    clearError()
    setSubmissionStatus()
    setErrorMessage()
    handleClose()
    dispatch({ type: 'PERMISSIONS_CHANGED' })
  }

  let content = (
    <>
      <div className="df jcsb">
        <p className="fz16 ml16 fw600">Edit role</p>
        <button className="bdnone m0 bgc-t" onClick={handleCancelModal}>
          <img src={clear} alt="cancel button" />
        </button>
      </div>
      <hr className="mt0 mb16 bdnone bt1-s-lightgray" />
      <div className="hfit w100% pl16 pr16 df jcsb fxdrr fxww">
        <div className="tal w100%">
          <form
            key={roleName}
            className="df fxdrr jcsb"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="tal w100%">
              <input
                className="bd1-s-lightgray mt4 lh2 fz15"
                type="text"
                name="new_role_name"
                ref={register({ required: true })}
                defaultValue={roleName || ''}
              />
              <div className="c-red tal fz13 mt5">
                {errors.new_role_name &&
                  errors.new_role_name.type === 'required' &&
                  'Role name is required. Please complete this field'}
              </div>
            </div>
          </form>
        </div>
        <div className="w100% bd1-s-lightgray bdrs-4 mt20">
          <div className="tal mt20 mb20">
            {options.map(d => {
              return (
                <div key={d.permission_code} className="df fxdrr tal mb10">
                  <label className="w100% tal fz15">
                    <input
                      className="w10% "
                      onChange={event => {
                        let isChecked = event.target.checked
                        setOptions(
                          options.map(data => {
                            if (d.permission_code === data.permission_code) {
                              data.isChecked = isChecked
                            }
                            return data
                          })
                        )
                      }}
                      type="checkbox"
                      checked={d.isChecked}
                    ></input>
                    {d.permission_name}
                  </label>
                </div>
              )
            })}
          </div>
        </div>
      </div>
      <hr className="mt20 mb16 bdnone bt1-s-lightgray" />
      <div className="df jcfe">
        <Button
          text="Cancel"
          customClassName="mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4"
          clickHandler={handleCancelModal}
        >
          Cancel
        </Button>
        <div data-testid="saveButton">
          <Button
            type="success"
            text="Save"
            clickHandler={handleSubmit(onSubmit)}
            customClassName="mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4"
          />
        </div>
      </div>
    </>
  )

  switch (submissionStatus) {
    case 'SUCCESS':
      content = (
        <div>
          <div className="df jcsb">
            <p className="fz16 ml20 fw600">Edit role</p>
          </div>
          <hr className="mt0 mb16 bdnone bt1-s-lightgray" />
          <p className="mt20">Successfully updated role: {<b>{roleName}</b>}</p>
          <div className="df jcfe mr25 mt20">
            <Button styleType="success" onClick={handleCancelModal}>
              Close
            </Button>
          </div>
        </div>
      )
      break
    case 'FAILED':
      content = (
        <div>
          <div className="df jcsb">
            <p className="fz16 ml20 fw600">Edit role</p>
          </div>
          <hr className="mt0 mb16 bdnone bt1-s-lightgray" />
          <p className="mt20">Failed to update role: {<b>{roleName}</b>} </p>
          {errorMessage}
          <div className="df jcfe mr25 mt20">
            <Button styleType="success" onClick={handleCancelModal}>
              Close
            </Button>
          </div>
        </div>
      )
      break
    case 'LOADING':
      content = (
        <div>
          <div className="df jcsb">
            <p className="fz16 ml20 fw600">Edit role</p>
          </div>
          <hr className="mt0 mb16 bdnone bt1-s-lightgray" />
          <div className="mt40 mb20">Updating role: {<b>{roleName}</b>}</div>
          <div>Please wait...</div>
          <TableStatus status={'LOADING'} />
        </div>
      )
      break
    default:
      break
  }

  return (
    <div className="w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40">
      {content}
    </div>
  )
}

export default EditRoleForm
